import * as S from './LinkButton.styles'

function LinkButton({ onClick, color, size, children, ...otherProps }) {
  return (
    <S.StyledMarginedDiv
      onClick={onClick}
      color={color}
      size={size}
      {...otherProps}
    >
      {children}
    </S.StyledMarginedDiv>
  )
}

export default LinkButton
